import React, { useState, useEffect } from 'react';
import { Briefcase, FileText, Clock, Trophy } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

const DashboardStatsBar = ({ token }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch(`${API}/business/dashboard-stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.ok) setStats(await res.json());
      } catch (error) {
        console.error('Failed to fetch dashboard stats');
      }
    };
    if (token) fetchStats();
  }, [token]);

  if (!stats) return null;

  const items = [
    { label: 'Open Posts', value: stats.open_posts, icon: FileText, color: 'text-blue-400' },
    { label: 'Pending Approvals', value: stats.pending_approvals, icon: Clock, color: 'text-yellow-400' },
    { label: 'Active Requests', value: stats.active_requests, icon: Briefcase, color: 'text-green-400' },
    { label: 'Deals Closed', value: stats.deals_closed, icon: Trophy, color: 'text-brand-gold' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="dashboard-stats-bar">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <div key={item.label} className="rounded-xl border border-white/10 bg-[#111317] p-4" data-testid={`stat-${item.label.toLowerCase().replace(/\s/g, '-')}`}>
            <div className="flex items-center gap-2 mb-1">
              <Icon className={`w-4 h-4 ${item.color}`} />
              <span className="text-xs text-brand-muted">{item.label}</span>
            </div>
            <div className="text-2xl font-bold text-brand-text">{item.value}</div>
          </div>
        );
      })}
    </div>
  );
};

export default DashboardStatsBar;
